import styled from 'styled-components';
import { TabPanel as RTTabPanel } from 'react-tabs';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';

export const TabPanel = styled(RTTabPanel)<MarginProps>(margin);
